import { useNavigate } from "react-router-dom";
import { Play, Pause, X, Maximize2 } from "lucide-react";
import { usePlayer } from "../contexts/PlayerContext";

export default function MiniPlayer() {
  const { current, playing, position, duration, setPlaying, close } = usePlayer();
  const nav = useNavigate();
  if (!current) return null;

  const pct = duration > 0 ? Math.min(100, (position / duration) * 100) : 0;
  const item = current.item;

  return (
    <div
      className="fixed bottom-[136px] lg:bottom-4 right-4 left-4 md:left-auto md:w-[400px] glass-panel rounded-2xl p-3 shadow-2xl z-50"
      data-testid="media-mini-player"
    >
      <div className="h-1 rounded-full bg-white/10 mb-3 overflow-hidden">
        <div className="h-full bg-[#D1CFC9] transition-all" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#D1CFC9]/30 to-[#978D78]/30 grid place-items-center text-[#E8E6E2] font-serif text-xl flex-shrink-0">
          {item.IsAudio ? "♪" : "▶"}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{item.Descricao}</p>
          <p className="text-xs text-slate-400">{item.IsAudio ? "Áudio" : "Vídeo"}</p>
        </div>
        <button
          onClick={() => setPlaying(!playing)}
          className="w-10 h-10 rounded-full bg-[#D1CFC9] text-[#0F1829] grid place-items-center hover:scale-105 transition"
          data-testid="media-mini-toggle"
        >
          {playing ? <Pause size={18} fill="currentColor" /> : <Play size={18} fill="currentColor" />}
        </button>
        <button
          onClick={() => nav(`/media/watch/${item.ID_ConteudoMediaCenter}`)}
          className="w-8 h-8 rounded-full hover:bg-white/10 grid place-items-center"
          data-testid="media-mini-expand"
          aria-label="Expandir"
        >
          <Maximize2 size={14} />
        </button>
        <button
          onClick={close}
          className="w-8 h-8 rounded-full hover:bg-white/10 grid place-items-center"
          data-testid="media-mini-close"
          aria-label="Fechar"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
